import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import {
    Button,
    Card,
    CardBody,
    Container,
    Row,
    Col,
    Form,
    FormGroup,
    InputGroupAddon,
    InputGroupText,
    Input,
    InputGroup,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Modal,
    ModalHeader,
    ModalBody,
    Badge,
    Carousel, CarouselItem, CarouselControl, CarouselIndicators, CarouselCaption

} from "reactstrap";
import {api} from '../../../../api';
import Cookies from "js-cookie";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

   



const Viewproject = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [showAddClientModal, setShowAddClientModal] = useState(false); // New state for Add Project modal
    const [clientForm, setClientForm] = useState({});
    
    const [selectedSiteManagers, setSelectedSiteManagers] = useState([

        { value: 'harish', label: 'harish' },
        { value: 'jyo', label: 'jyo' }
    ]);
    const [image, setImage] = useState(null);
    const [profileImage, setProfileImage] = useState(null);


 

    const toggleModal = () => setModalOpen(prevState => !prevState);
    const toggleAddClientModal = () => setShowAddClientModal(prevState => !prevState); // Function to toggle Add Project modal

    const handleFormSubmit = (e) => {
        e.preventDefault();
        // Handle form submission logic here
        console.log("Form submitted:", clientForm);
        // Reset form fields after submission (if needed)
        setClientForm({
            name: '',
            status: '',
            Timeline: '',
            Budget: '',
            Experiences: '',
            Reviews: '',
            Contact: '',
            Payment: '',

        });
        // Close the modal after submission (if needed)
        setShowAddClientModal(false);
    };

    const [searchQuery, setSearchQuery] = useState('');
    const [filteredEmployees, setFilteredEmployees] = useState([]);
    const [selectedManager, setSelectedManager] = useState('');
    const [selectedLocation, setSelectedLocation] = useState('');



    // Sample employee data (replace with your actual data)
    const employees = [
        { id: 1, name: 'Mine', age: 2022, location: 'Developers', position: 'Mine Description', image: require("../../assets/img/theme/team-4-800x800.jpg"), dropdownOpen: false },
        { id: 2, name: 'AecEarth', age: 2021, location: 'Career', position: 'AecEarth Description', image: require("../../assets/img/theme/team-4-800x800.jpg"), dropdownOpen: false },
        { id: 3, name: 'Swifter', age: 2000, location: 'Sales', position: 'Swifter Description', image: require("../../assets/img/theme/team-4-800x800.jpg"), dropdownOpen: false },
        { id: 4, name: 'BIM', age: 2023, location: 'Construction', position: 'BIM Description', image: require("../../assets/img/theme/team-4-800x800.jpg"), dropdownOpen: false },
        // Add more employees as needed
    ];

    // Function to toggle dropdown for a specific employee
    const toggleDropdown = (employeeId) => {
        setFilteredEmployees(prevEmployees => prevEmployees.map(employee => {
            if (employee.id === employeeId) {
                return { ...employee, dropdownOpen: !employee.dropdownOpen };
            }
            return employee;
        }));
    };

    // Function to filter employees based on search query
    const filterEmployees = () => {
        if (!searchQuery) {
            setFilteredEmployees(employees);
        } else {
            const filtered = employees.filter(employee =>
                employee.name.toLowerCase().includes(searchQuery.toLowerCase())
            );
            setFilteredEmployees(filtered);
        }
    };



    // Update filtered employees when searchQuery changes
    useEffect(() => {
        filterEmployees();
    }, [searchQuery]);


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setClientForm(prevState => ({
            ...prevState,
            file: file
        }));
    };

    const handleManagerSelectChange = (selectedOption) => {
        setSelectedManager(selectedOption);
    };

    const handleLocationSelectChange = (selectedOption) => {
        setSelectedLocation(selectedOption);
    };

    const handleSiteManagerSelectChange = (selectedOptions) => {
        setSelectedSiteManagers(selectedOptions);
        setClientForm(prevState => ({
            ...prevState,
            siteManagers: selectedOptions.map(option => option.value)
        }));
    };
    const siteOptions = [
        { value: 'harish', label: 'harish' },
        { value: 'jyo', label: 'jyo' },
        { value: 'rifwhuiw', label: 'harisrkbfkrwefh' },
        { value: 'jyrefkerwo', label: 'jrebfkjrwyo' },
    ];



    const [activeIndex, setActiveIndex] = useState(0);
    const [animating, setAnimating] = useState(false);
    const [profileImages, setProfileImages] = useState([]);
    

    const handleFileUpload = (event) => {
        const files = event.target.files;
        const uploadedImagesArray = [];
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const reader = new FileReader();
            reader.onload = function (e) {
                const path = URL.createObjectURL(file);

                uploadedImagesArray.push({ name: file.name, data: path });
                if (uploadedImagesArray.length === files.length) {
                    setProfileImages(uploadedImagesArray);
                }
            };
            console.log(uploadedImagesArray);
            reader.readAsDataURL(file);
        }
    };
    
    


    const next = () => {
        if (animating) return;
        const nextIndex = activeIndex === profileImages.length - 1 ? 0 : activeIndex + 1;
        setActiveIndex(nextIndex);
    }

    const previous = () => {
        if (animating) return;
        const nextIndex = activeIndex === 0 ? profileImages.length - 1 : activeIndex - 1;
        setActiveIndex(nextIndex);
    }

    const goToIndex = (newIndex) => {
        if (animating) return;
        setActiveIndex(newIndex);
    }

    const slides = profileImages.map((image, index) => (
        <CarouselItem
            onExiting={() => setAnimating(true)}
            onExited={() => setAnimating(false)}
            key={index}
        >
            <div className="profile-image-container" style={{
                width: '376px',
                height: '256px',
                border: '2px solid black',
                borderRadius: '9%',
                overflow: 'hidden',
                boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
                margin: '0 auto',
            }}>
                <img
                    src={image.data}
                    alt={`Uploaded Image ${index + 1}`}
                    style={{
                        width: '100%',
                        height: '100%',
                    }}
                />
            </div>
            <CarouselCaption captionText={image.name} captionHeader="" />
        </CarouselItem>
    ));
    
    const renderUploadedFiles = () => {
        return uploadedImages.map((file, index) => (
            <div key={index}>
                <p>File {index + 1}: {file.name}</p>
            </div>
        ));
    };
    const [uploadedImages, setUploadedImages] = useState([]);


    const [dropdownOpen2, setDropdownOpen2] = useState(false);
    const toggleDropdown2 = () => setDropdownOpen2(prevState => !prevState);
    
    const {id} = useParams();

    const [loading, setLoading] = useState(true);
    const [projectData, setprojectData] = useState();
    const [currentStatus, setCurrentStatus] = useState('');
    const [roleNames, setRoleNames] = useState({
        projectManager: 'Project Manager',
        generalManager: 'General Manager',
        siteManager: 'Site Manager'
    });

    // Function to fetch role names for the company
    const fetchRoleNames = async (company_id) => {
        try {
            const response = await api.get(`roleConfig.php?company_id=${company_id}`);
            if (response.data && response.data.status === 'success') {
                const roles = response.data.data;
                const roleMap = {};
                
                console.log("Fetched roles for company:", roles);
                
                roles.forEach(role => {
                    if (role.role_name) {
                        // Map based on dashboard path to identify role types
                        if (role.dashboard_path.includes('project-management')) {
                            // For project management roles, take any role name from this dashboard path
                            // This works like General Manager - picks up any custom name
                            roleMap.projectManager = role.role_name;
                        } else if (role.dashboard_path.includes('general-management')) {
                            roleMap.generalManager = role.role_name;
                        } else if (role.dashboard_path.includes('site-management')) {
                            // For site management roles, take any role name from this dashboard path
                            // This works like General Manager - picks up any custom name
                            roleMap.siteManager = role.role_name;
                        }
                    }
                });
                
                console.log("Mapped role names:", roleMap);
                
                setRoleNames(prev => ({
                    ...prev,
                    ...roleMap
                }));
            }
        } catch (error) {
            console.error("Error fetching role names:", error);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const company_id = Cookies.get('company_id');
                
                // Fetch project data and role names in parallel
                const [projectResponse] = await Promise.all([
                    api.get(`viewProjectByID.php?p_id=${id}&company_id=${company_id}`),
                    fetchRoleNames(company_id)
                ]);
                
                setprojectData(projectResponse.data);
                console.log(projectData);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        if (projectData && projectData.length > 0) {
            setCurrentStatus(projectData[0].p_status);
        }
    }, [projectData]);

    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case 'to-do': return '#F7D800';
            case 'in-progress': return '#00BFFF';
            case 'completed': return '#68D241';
            default: return '#e0e0e0';
        }
    };

    const handleStatusChange = async (newStatus) => {
        try {
            const company_id = Cookies.get('company_id');
            await api.get(`viewProjectByID.php?p_id=${id}&status=${newStatus}&company_id=${company_id}`);
            setCurrentStatus(newStatus);
        } catch (error) {
            alert('Failed to update status');
        }
    };

    const sumbitprojectstatus = async(status)=>{
        const data = {
            p_id : id,
            status : status
        }

        console.log(data)
        try {
            const company_id = Cookies.get('company_id');
            const response = await api.get(`viewProjectByID.php?p_id=${id}&status=${status}&company_id=${company_id}`);
            console.log("Data sent successfully:", response.data);
            // window.location.reload();
        } catch (error) {
            console.error("Error submitting data:", error);
        }

        // console.log(id + "hello" + data)
    }

    const handleGenerateReport = async () => {
        const company_id = Cookies.get('company_id');
        let url = `pdfgenarateproject.php?p_report_id=${id}&company_id=${company_id}`;
    
    
        try {
            const response = await api.get(url);
            const path = response.data.path;
            console.log('PDF path from backend:', path);

            // Updated path handling for both production and local environments
            const baseURL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
                ? 'http://localhost:8000/'
                : 'https://aecp.aecearth.io/'; // Use your production domain

            // Remove any leading slash from path to avoid double slashes
            const fileUrl = baseURL + path.replace(/^\/+/, '');

            // Open in new tab
            window.open(fileUrl, '_blank', 'noopener,noreferrer');
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    



    return (
        <>
            <div className="header bg-gradient-info py-7 py-lg-8">
                <Col className="order-xl-2 mb-5 mb-xl-0 text-center">
                    <h1>View Project Details</h1>
                </Col>
                <Link to="/project-admin/project-management/project"> <Button className='ml-5' style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}}>Back</Button></Link>
                <Container className="py-4">
                    <div className="d-flex justify-content-center">
                        <div
                            className="p-4 rounded project-details-card"
                           style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px'}}
                        >
                            {projectData && ((Array.isArray(projectData) && projectData.length > 0) || (typeof projectData === 'object' && Object.keys(projectData).length > 0)) && (
                                <>
                                    <div className="row mb-4">
                                        <div className="col-md-6 col-12 mb-2">
                                            <label className="fw-bold">Project Status</label>
                                            <div>
                                                <span
                                                    style={{
                                                        background: getStatusColor(currentStatus),
                                                        color: '#111',
                                                        fontWeight: 'bold',
                                                        padding: '8px 22px',
                                                        borderRadius: '7px',
                                                        display: 'inline-block',
                                                        minWidth: 80,
                                                        textAlign: 'center',
                                                    }}
                                                >
                                                    {currentStatus?.toUpperCase() ||(Array.isArray(projectData) ? projectData[0] : projectData).p_status }
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-12 mb-2">
                                            <label className="fw-bold">Project Status</label>
                                            <Dropdown isOpen={dropdownOpen2} toggle={toggleDropdown2}>
                                                <DropdownToggle caret>
                                                    {currentStatus ? currentStatus : "Select Status"}
                                                </DropdownToggle>
                                                <DropdownMenu>
                                                    <DropdownItem onClick={() => handleStatusChange('To-Do')}>To-Do</DropdownItem>
                                                    <DropdownItem onClick={() => handleStatusChange('In-Progress')}>In-Progress</DropdownItem>
                                                    <DropdownItem onClick={() => handleStatusChange('Completed')}>Completed</DropdownItem>
                                                </DropdownMenu>
                                            </Dropdown>
                                        </div>
                                    </div>
                                    <div className="row g-3">
                                        <div className="col-md-6 col-12 mb-2">
                                            <label className="fw-bold">Project Name:</label>
                                            <div>{(Array.isArray(projectData) ? projectData[0] : projectData).p_name}</div>
                                        </div>
                                        <div className="col-md-6 col-12 mb-2">
                                            <label className="fw-bold">Client Name:</label>
                                            <div>{(Array.isArray(projectData) ? projectData[0] : projectData).client_name}</div>
                                        </div>
                                    </div>
                                    <div className="row g-3" style={{ display: 'flex', flexWrap: 'wrap', rowGap: '18px', columnGap: '0' }}>
                                        <div className="col-md-6 col-12 mb-2">
                                            <label className="fw-bold">Status:</label>
                                            <div>{(Array.isArray(projectData) ? projectData[0] : projectData).p_status}</div>
                                        </div>
                                        <div className="col-md-6 col-12 mb-2">
                                            <label className="fw-bold">Budget:</label>
                                            <div>{(Array.isArray(projectData) ? projectData[0] : projectData).p_budget}</div>
                                        </div>
                                        <div className="col-md-6 col-12 mb-2">
                                            <label className="fw-bold">Department Name:</label>
                                            <div style={{ wordBreak: 'break-word' }}>
                                                {Array.isArray((Array.isArray(projectData) ? projectData[0] : projectData).department_names)
                                                    ? (Array.isArray(projectData) ? projectData[0] : projectData).department_names.join(', ')
                                                    : (Array.isArray(projectData) ? projectData[0] : projectData).department_names}
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-12 mb-2">
                                            <label className="fw-bold">{roleNames.projectManager}:</label>
                                            <div>{(Array.isArray(projectData) ? projectData[0] : projectData).project_manager_name}</div>
                                        </div>
                                        <div className="col-md-6 col-12 mb-2">
                                            <label className="fw-bold">{roleNames.generalManager} Name:</label>
                                            <div>{(Array.isArray(projectData) ? projectData[0] : projectData).gm_name}</div>
                                        </div>
                                        <div className="col-md-6 col-12 mb-2">
                                            <label className="fw-bold">{roleNames.siteManager}s:</label>
                                            <div style={{ wordBreak: 'break-word' }}>
                                                {Array.isArray((Array.isArray(projectData) ? projectData[0] : projectData).site_manager_names)
                                                    ? (Array.isArray(projectData) ? projectData[0] : projectData).site_manager_names.join(', ')
                                                    : (Array.isArray(projectData) ? projectData[0] : projectData).site_manager_names}
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-12 mb-2">
                                            <label className="fw-bold">Start Date:</label>
                                            <div>{(Array.isArray(projectData) ? projectData[0] : projectData).start_date}</div>
                                        </div>
                                        <div className="col-md-6 col-12 mb-2">
                                            <label className="fw-bold">End Date:</label>
                                            <div>{(Array.isArray(projectData) ? projectData[0] : projectData).end_date}</div>
                                        </div>
                                        <div className="col-md-6 col-12 mb-2">
                                            <label className="fw-bold">Location:</label>
                                            <div>{(Array.isArray(projectData) ? projectData[0] : projectData).p_location}</div>
                                        </div>
                                        <div className="col-md-6 col-12 mb-2">
                                            <label className="fw-bold">Project Description:</label>
                                            <div style={{ whiteSpace: 'pre-line' }}>{(Array.isArray(projectData) ? projectData[0] : projectData).p_description && (Array.isArray(projectData) ? projectData[0] : projectData).p_description.replace(/<\/?[^>]+(>|$)/g, '')}</div>
                                        </div>
                                        <div className="col-md-6 col-12 mb-2">
                                            <label className="fw-bold">BOQ File:</label>
                                            <div style={{ wordBreak: 'break-all' }}>
                                                {(() => {
                                                    const file = (Array.isArray(projectData) ? projectData[0] : projectData).BOQ;
                                                    if (!file) return null;
                                                    if (isPdf(file)) {
                                                        return <a href={getFileUrl(file)} target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faDownload} /> {file}</a>;
                                                    } else if (isExcel(file)) {
                                                        return <a href={getFileUrl(file)} download><FontAwesomeIcon icon={faDownload} /> {file}</a>;
                                                    } else {
                                                        return <a href={getFileUrl(file)}><FontAwesomeIcon icon={faDownload} /> {file}</a>;
                                                    }
                                                })()}
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-12 mb-2">
                                            <label className="fw-bold">BOM File:</label>
                                            <div style={{ wordBreak: 'break-all' }}>
                                                {(() => {
                                                    const file = (Array.isArray(projectData) ? projectData[0] : projectData).BOM;
                                                    if (!file) return null;
                                                    if (isPdf(file)) {
                                                        return <a href={getFileUrl(file)} target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faDownload} /> {file}</a>;
                                                    } else if (isExcel(file)) {
                                                        return <a href={getFileUrl(file)} download><FontAwesomeIcon icon={faDownload} /> {file}</a>;
                                                    } else {
                                                        return <a href={getFileUrl(file)}><FontAwesomeIcon icon={faDownload} /> {file}</a>;
                                                    }
                                                })()}
                                            </div>
                                        </div>
                                        <div className="col-12 mb-2">
                                            <label className="fw-bold">Documents:</label>
                                            <div style={{ wordBreak: 'break-all' }}>
                                                {(Array.isArray(projectData) ? projectData[0] : projectData).files && (Array.isArray(projectData) ? projectData[0] : projectData).files.split(',').map((file, index) => (
                                                    <div key={index}>
                                                        File {index + 1} : {isPdf(file) ? (
                                                            <a href={getFileUrl(file)} target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faDownload} /> {file}</a>
                                                        ) : isExcel(file) ? (
                                                            <a href={getFileUrl(file)} download><FontAwesomeIcon icon={faDownload} /> {file}</a>
                                                        ) : (
                                                            <a href={getFileUrl(file)}><FontAwesomeIcon icon={faDownload} /> {file}</a>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        
                                    </div>
                                    <div className="col-12 d-flex align-items-center justify-content-center mt-4">
                                        <Button className='btn btn-success' style={{ minWidth: 180, fontWeight: 600, backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black' }} onClick={handleGenerateReport}>
                                            Download Project Report
                                        </Button>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </Container>

            </div>


        </>
    );
};

function getFileUrl(filename) {
  if (!filename) return "#";
  return `/images/${filename}`;
}

function isPdf(filename) {
  return filename && filename.toLowerCase().endsWith('.pdf');
}

function isExcel(filename) {
  return filename && (
    filename.toLowerCase().endsWith('.xls') ||
    filename.toLowerCase().endsWith('.xlsx') ||
    filename.toLowerCase().endsWith('.csv')
  );
}

export default Viewproject;
